import type { LastMileCarrierConfig } from '../../../domain/types/configs/company/LastMileCarrierConfig';

export const lastMileCarrierConfig: LastMileCarrierConfig = {
  lastMileCarrier:[],
  showAll: true
}; 